/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type TaskListItemOrigin = typeof TaskListItemOrigin[keyof typeof TaskListItemOrigin];


export const TaskListItemOrigin = {
  sequence: 'sequence',
  manual_job: 'manual_job',
} as const;
